import {
  csvDataExportFastReportMiscellaneous,
  csvDataExportReportMiscellaneous,
} from '../../reportsTypes';
import { SelectType } from '@ais-ui/ui-core';

export const parseCsvMiscellaneousDataFields = (
  inputValues: string[],
): SelectType[] => {
  const dataFieldOptions = csvDataExportReportMiscellaneous.dataFields.options;

  const chosenDataFields: SelectType[] = [];
  if (!dataFieldOptions) {
    return chosenDataFields;
  }

  dataFieldOptions.forEach((dataFieldOption) => {
    if (inputValues.includes(dataFieldOption.value)) {
      chosenDataFields.push({
        label: dataFieldOption.label,
        value: dataFieldOption.value,
      });
    }
  });

  return chosenDataFields;
};

export const parseCsvMiscellaneousMessageTypes = (
  inputValues: string[] | null,
) => {
  const messageTypeOptions =
    csvDataExportReportMiscellaneous.messageType.options;

  if (!messageTypeOptions) {
    return;
  }

  const chosenMessageTypes: SelectType[] = [];
  messageTypeOptions.forEach((messageTypeOption) => {
    if (inputValues && inputValues.includes(messageTypeOption.value)) {
      chosenMessageTypes.push({
        label: messageTypeOption.label,
        value: messageTypeOption.value,
      });
    }
  });

  return messageTypeOptions;
};

export const parseCsvFastMiscellaneousDataFields = (
  inputValues: string[] | null | undefined,
): SelectType[] => {
  const dataFieldOptions =
    csvDataExportFastReportMiscellaneous.dataFields.options;

  if (!dataFieldOptions || !Array.isArray(inputValues)) {
    return [];
  }

  // Preserve the saved CSVP order (it drives the drag-and-drop export
  // column order), rather than the fixed order of `dataFieldOptions`.
  const chosenDataFields: SelectType[] = [];
  inputValues.forEach((inputValue) => {
    const dataFieldOption = dataFieldOptions.find(
      (option) => option.value === inputValue,
    );
    if (dataFieldOption) {
      chosenDataFields.push({
        label: dataFieldOption.label,
        value: dataFieldOption.value,
      });
    }
  });

  return chosenDataFields;
};
